export const initialState = {
  mode: "POST",
  movementIdSelected: 0,
  defaultData: {},
};

export const SET_MODE = "[STACK_INSUMOS] SET_MODE";
export const SET_MOVEMENT_ID = "[STACK_INSUMOS] SET_MOVEMENT_ID";
export const SET_DEFAULT_DATA = "[STACK_INSUMOS] SET_DEFAULT_DATA";

export const setMode = (payload) => ({ type: SET_MODE, payload });
export const setMovementId = (payload) => ({ type: SET_MOVEMENT_ID, payload });
export const setDefaultData = (payload) => ({ type: SET_DEFAULT_DATA, payload });

export default function Reducer(state = initialState, { type, payload }) {
  switch (type) {
    case SET_MODE:
      return { ...state, mode: payload };
    case SET_MOVEMENT_ID:
      return { ...state, movementIdSelected: payload };
    case SET_DEFAULT_DATA:
      return { ...state, defaultData: payload };
    default:
      return state;
  }
}
